import React from 'react';
import { useAuth } from '../context/AuthContext';
import { FiGrid, FiPhone, FiUsers, FiLogOut, FiUser } from 'react-icons/fi';
// --- CRM layer nav (added Phase 6-B, additive) -----------------------------
import { FiInbox, FiTrendingUp, FiTarget } from 'react-icons/fi';
import { crmTransferCount } from '../crm/crmApi';
import { hasPerm } from '../crm/perms';
// ---------------------------------------------------------------------------

const Sidebar = ({ activePage, setActivePage }) => {
  const { user, logout } = useAuth();

  // Added Phase 6-B: pending follow-up transfers waiting for this user.
  const [crmInbox, setCrmInbox] = React.useState(0);
  React.useEffect(() => {
    if (!user) return undefined;
    let alive = true;
    const poll = () => crmTransferCount()
      .then((r) => { if (alive) setCrmInbox(r.data.count); })
      .catch(() => {});
    poll();
    const t = setInterval(poll, 30000);
    return () => { alive = false; clearInterval(t); };
  }, [user]);

  const navItems = [
    { id: 'calls', label: 'المكالمات', icon: <FiPhone /> },
    { id: 'mycalls', label: 'مكالماتي', icon: <FiPhone /> },
    // Phase 6-C: the old 'contacts' ("العملاء") entry was REMOVED from the nav
    // so there is exactly one client screen. ContactsPage.js and /api/contacts
    // are untouched and still reachable; the old record is now surfaced inside
    // the CRM client profile instead.
  ];

  // --- CRM layer nav entries (added Phase 6-B, extended 6-C) ---------------
  navItems.push({ id: 'crm-board', label: 'الفرص', icon: <FiTarget /> });
  navItems.push({ id: 'crm-client', label: 'ملفات العملاء', icon: <FiUser /> });
  // A.5: the transfers inbox is only for users who may manage transfers.
  if (hasPerm(user, 'manage_transfers')) {
    navItems.push({
      id: 'crm-transfers',
      label: 'متابعات محوّلة إلينا',
      icon: <FiInbox />,
      // Styling only: the pending count used to be appended to the label text
      // as "(3)". Same value, same >0 condition, same source (crmInbox) — it is
      // now rendered as a small soft pill next to the label instead.
      badge: crmInbox > 0 ? crmInbox : null
    });
  }
  // ---------------------------------------------------------------------------

  if (user?.role === 'admin') {
    navItems.unshift({ id: 'dashboard', label: 'لوحة التحكم', icon: <FiGrid /> });
    navItems.push({ id: 'reports', label: 'التقارير', icon: <FiGrid /> });
    navItems.push({ id: 'users', label: 'المستخدمين', icon: <FiUsers /> });
    // Added Phase 6-B: CRM admin console (dashboard, settings, types, departments)
    navItems.push({ id: 'crm-admin', label: 'إدارة الـ CRM', icon: <FiTrendingUp /> });
  }

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <h1>CallTrack Pro</h1>
        <span>نظام إدارة المكالمات</span>
      </div>

      <nav className="sidebar-nav">
        {navItems.map(item => (
          <button
            key={item.id}
            className={`nav-item ${activePage === item.id ? 'active' : ''}`}
            onClick={() => setActivePage(item.id)}
          >
            <span className="icon">{item.icon}</span>
            <span>{item.label}</span>
            {item.badge != null && <span className="nav-badge">{item.badge}</span>}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {user?.fullName?.charAt(0) || 'U'}
          </div>
          <div>
            <div className="user-name">{user?.fullName}</div>
            <div className="user-role">{user?.role === 'admin' ? 'مدير' : 'موظف'} — تحويلة {user?.extension}</div>
          </div>
        </div>
        <button className="logout-btn" onClick={logout}>
          <FiLogOut style={{ marginLeft: 6 }} />
          <span>تسجيل خروج</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;